import PropTypes from 'prop-types'
import { Component } from 'react'

export default class MFAImage extends Component {
  state = {
    error: false
  }

  handleError = () => {
    this.setState({
      error: true
    })
  }

  render() {
    const { error } = this.state
    const { errorMessage, src, ...rest } = this.props

    if (error) {
      return <p data-test-image-load-error>{errorMessage}</p>
    } else {
      return <img src={src} onError={this.handleError} {...rest} />
    }
  }
}

MFAImage.propTypes = {
  src: PropTypes.string.isRequired,
  errorMessage: PropTypes.string
}

MFAImage.defaultProps = {
  errorMessage:
    "We're having trouble loading this image. Please try again later."
}
